import { useCallback } from 'react';
import { useSelector, shallowEqual } from 'react-redux';

export default function usePender() {
	const { pending, success, failure } = useSelector((state) => state.pender, shallowEqual);

	const getPending = useCallback((actionType) => pending[actionType], [pending]);
	const getSuccess = useCallback((actionType) => success[actionType], [success]);
	const getFailure = useCallback((actionType) => failure[actionType], [failure]);

	return {
		getPending,
		getSuccess,
		getFailure,
	};
}
